/* Shared star renderer + inline/card rating injection.

   PLACEHOLDER DATA. See REVIEWS-SPEC.md.

   Two-layer SVG so a 4.7 renders as a genuine 93.2% fill rather than rounding
   to the nearest half star - the treatment the Vercel build used, kept here so
   the PDP line, the collection cards and the review list all read as one system.
   Runs on every page: injects the inline summary under a PDP title and a rating
   line between title and price on product cards. */
window.RumpusStars = (function () {
  var PATH = 'M12 17.27 18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z';
  var SVG = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="' + PATH + '"/></svg>';

  function stars(pct, size) {
    return '<span class="rvw-stars ' + (size || '') + '" style="--pct:' + pct + '%">'
      + '<span class="rvw-sb">' + SVG + SVG + SVG + SVG + SVG + '</span>'
      + '<span class="rvw-sf">' + SVG + SVG + SVG + SVG + SVG + '</span></span>';
  }

  var dataPromise = null;
  function load() {
    if (!dataPromise) {
      var src = document.querySelector('[data-rvw-src]');
      var url = src ? src.getAttribute('data-rvw-src') : null;
      dataPromise = url
        ? fetch(url).then(function (r) { return r.json(); }).catch(function () { return {}; })
        : Promise.resolve({});
    }
    return dataPromise;
  }

  function summarise(rows) {
    if (!rows || !rows.length) return null;
    var sum = 0; for (var i = 0; i < rows.length; i++) sum += rows[i].r;
    var avg = sum / rows.length;
    return { avg: avg, n: rows.length, pct: (avg / 5 * 100).toFixed(1) };
  }

  /* handle from a product URL, so cards and the PDP resolve the same way */
  function handleFrom(href) {
    var m = String(href || '').match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  function mountInline(data) {
    var sec = document.getElementById('rvwp');
    if (!sec) return;
    var handle = sec.getAttribute('data-handle');
    var s = summarise(data[handle]);
    if (!s) return;
    /* under the product title, above the price - where every furniture site puts it */
    var h1 = document.querySelector('.product-title h1, .product__title h1, h1.product-title, main h1');
    if (!h1 || h1.parentNode.querySelector('.rvw-inline')) return;
    var a = document.createElement('a');
    a.className = 'rvw-inline';
    a.href = '#reviews';
    a.setAttribute('aria-label', s.avg.toFixed(1) + ' out of 5 stars, ' + s.n + ' reviews');
    a.innerHTML = stars(s.pct, 'rvw-sm') + '<b>' + s.avg.toFixed(1) + '</b><span>(' + s.n + ')</span>';
    a.addEventListener('click', function (e) {
      e.preventDefault();
      var t = document.getElementById('rvwp');
      if (t) t.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    h1.insertAdjacentElement('afterend', a);
  }

  function mountCards(data) {
    var links = document.querySelectorAll('a[href*="/products/"]');
    var seen = {};
    for (var i = 0; i < links.length; i++) {
      /* body carries card-hover-effect-none, so a loose [class*="card"] match
         walks all the way up to <body>. Anchor on real card wrappers only. */
      var card = links[i].closest('li, .card, .ru-card, .product-card, .card-wrapper, .product-grid__item, [class*="card"]:not(body):not(html)');
      if (card === document.body || card === document.documentElement) card = null;
      if (!card || card.querySelector('.rvw-cardrate')) continue;
      /* never inside the PDP buy box: it holds a link to its own product, which
         put a second rating line directly under the inline summary */
      if (card.querySelector('h1') || card.closest('#rvwp') || card.querySelector('.rvw-inline')) continue;
      if (document.getElementById('rvwp') && card.contains(document.querySelector('h1'))) continue;
      var handle = handleFrom(links[i].getAttribute('href'));
      if (!handle) continue;
      var s = summarise(data[handle]);
      if (!s) continue;
      /* between the card title and its price, matching the Vercel grid */
      var price = card.querySelector('[class*="price"]');
      var title = card.querySelector('[class*="title"], h3, h2');
      var anchor = price || title;
      if (!anchor) continue;
      var d = document.createElement('div');
      d.className = 'rvw-cardrate';
      d.setAttribute('aria-label', s.avg.toFixed(1) + ' out of 5 stars, ' + s.n + ' reviews');
      d.innerHTML = stars(s.pct, 'rvw-xs') + '<span>' + s.avg.toFixed(1) + ' (' + s.n + ')</span>';
      /* If the title and price already share a flex row (this theme lays them
         out with space-between), a third item between them squeezes the title
         into a two-line wrap. Give the rating its own line under that row
         instead. Otherwise sit it above the price, as the Vercel grid did. */
      var row = price && price.parentElement;
      var sharedRow = row && title && row.contains(title)
                      && /flex|grid/.test(getComputedStyle(row).display);
      if (sharedRow) { d.classList.add('rvw-cardrate-own'); row.insertAdjacentElement('afterend', d); }
      else if (price) price.insertAdjacentElement('beforebegin', d);
      else title.insertAdjacentElement('afterend', d);
      seen[handle] = 1;
    }
  }


  /* Total-reviews badge in the announcement bar. Pinned right rather than added
     as a fourth rotating slide, so the number is always on screen instead of
     visible one second in four. Pointer-events off so it never swallows the
     bar's tap-to-advance. */
  function mountBanner(data) {
    var bar = document.getElementById('annc');
    if (!bar || bar.querySelector('.rvw-annc')) return;
    var n = 0, sum = 0;
    for (var h in data) {
      if (!data.hasOwnProperty(h) || !data[h].length) continue;
      for (var i = 0; i < data[h].length; i++) { n++; sum += data[h][i].r; }
    }
    if (!n) return;
    var avg = (sum / n).toFixed(1);
    var b = document.createElement('span');
    b.className = 'rvw-annc';
    b.setAttribute('aria-label', avg + ' out of 5 stars from ' + n + ' reviews');
    b.innerHTML = stars((sum / n / 5 * 100).toFixed(1), 'rvw-xs')
      + '<b>' + avg + '</b>'
      + '<span class="rvw-annc-n">' + n.toLocaleString() + ' reviews</span>'
      + '<span class="rvw-annc-s">' + n.toLocaleString() + '</span>';
    bar.appendChild(b);
    bar.classList.add('has-rvw-annc');

    /* Reserve exactly the room the badge takes rather than guessing a padding
       per breakpoint: the count changes length as reviews come in, and a fixed
       value either clips the slide copy or wastes bar width. */
    var setPad = function () {
      var w = Math.ceil(b.getBoundingClientRect().width);
      var pad = window.innerWidth <= 600 ? 14 : 26;
      if (w) bar.style.setProperty('--rvw-annc-w', (w + pad) + 'px');
    };
    setPad();
    if (window.ResizeObserver) new ResizeObserver(setPad).observe(b);
    window.addEventListener('resize', setPad);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(setPad);
  }

  function mount() {
    load().then(function (data) {
      try { mountInline(data); } catch (e) {}
      try { mountCards(data); } catch (e) {}
      try { mountBanner(data); } catch (e) {}
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount);
  else mount();

  return { stars: stars, load: load, summarise: summarise, mount: mount };
})();
